import React from 'react'
import socketio from "socket.io-client";
import { config } from './config';
import {GSWebRTCWrapper} from './GSWebRTCWrapper';

export const socket = socketio.connect(config.SOCKET_URL);
export const SocketContext = React.createContext();
export const wrapper = GSWebRTCWrapper(socket);
